import type { LngLat } from '../types/Geo';
import { decodeSegmentLngLat } from './legacyGeoJSONConversions';

/** Decodes the encoded `polyline` a trail search result carries */
const decodeTrailPolyline = (polyline: string) => decodeSegmentLngLat({ polyline: { pointsData: polyline } }) as LngLat[];

export default decodeTrailPolyline;
